import { Aurelia, LogManager, ViewLocator } from 'aurelia-framework';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { I18N, TCustomAttribute } from 'aurelia-i18n';
import { HttpClient } from 'aurelia-fetch-client';
import * as Backend from 'i18next-xhr-backend';
import { Config } from 'Config';
import Environment from 'Environment';
import { EventAggregator } from 'aurelia-event-aggregator';
import { LocalStorageHelper } from 'Code/Helpers/LocalStorageHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import {AnalyticsService} from "./Code/Services/AnalyticsService";
import {AutoAnalyticsTracker} from "./Code/Services/AutoAnalyticsTracker";

Config.Init();

(<any>Promise).config({
    warnings: {
        wForgottenReturn: false
    }
});

export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

//LogManager.addAppender(new CustomLogger());
LogManager.setLevel(LogManager.logLevel.debug);

export function configure(aurelia: Aurelia) {
    //
    aurelia.use
        .standardConfiguration()
        .plugin('aurelia-validation')
        .plugin('aurelia-dialog')
        .plugin('aurelia-i18n', (instance) => {
            let aliases = ['t', 'i18n'];

            TCustomAttribute.configureAliases(aliases);

            instance.i18next.use(Backend);

            // adapt options to your needs (see http://i18next.com/docs/options/)
            // make sure to return the promise of the setup method, in order to guarantee proper loading
            return instance.setup({
                backend: {                                    // <-- configure backend settings
                    loadPath: './locales/{{lng}}/{{ns}}.json', // <-- XHR settings for where to get the files from
                },
                attributes: aliases,
                lng: 'en',
                fallbackLng: 'en',
                debug: false
            });
        });

    // Clear local storage 
    LocalStorageHelper.ClearStartsWith(Config.TokenName() + '_M_');


    aurelia.use.singleton(AnalyticsService, AnalyticsService);
    aurelia.use.singleton(AutoAnalyticsTracker, AutoAnalyticsTracker);

    // define standard resources
    let resourceList = [
        './Instance/Default/Resources/Elements/TextBox/TextBox',
        './Instance/Default/Resources/Elements/DropDownList/DropDownList',
        './Instance/Default/Resources/Elements/TextArea/TextArea',
        './Instance/Default/Resources/Elements/CheckBox/CheckBox',
        './Instance/Default/Resources/Elements/DatePicker/DatePicker',
        './Instance/Default/Resources/Elements/TextBoxFilter/TextBoxFilter',
        './Instance/Default/Resources/Elements/StarRating/StarRating',
        './Instance/Default/Resources/Elements/Range/Range',
        './Instance/Default/Resources/Elements/PhotoSlider/PhotoSlider',
        './Instance/Default/Resources/Elements/UserAvatar/UserAvatar',
        './Instance/Default/Resources/Elements/EntityPicker/EntityPicker',
        './Instance/Default/Resources/Elements/PictureBox/PictureBox',

        './General/Resources/Parts/CheckBox/CheckBoxBirds',

        './Instance/Default/Resources/Parts/HomePage/HomePage',
        './General/Resources/Parts/Elements/AircraftList/AircraftList',
        './General/Resources/Parts/Elements/ReviewBlock/ReviewBlock',
        './General/Resources/Parts/Elements/ReviewList/ReviewList',
        './General/Resources/Parts/Elements/OperatorCard/OperatorCard',
        './General/Resources/Parts/Elements/ReviewForm/ReviewForm',


        './Instance/Default/Resources/ValueConverters/Pagination',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnItemGrid',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnGrid',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnGridWithSettings',
        './Instance/Default/Resources/ValueConverters/IsEnabledOnGrid',
        './Instance/Default/Resources/ValueConverters/IsEnabledOnGridWithSettings',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnForm',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnFilter',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnTooltip',
        './Instance/Default/Resources/ValueConverters/IsVisibleOnFilterNotEmpty',
        './Instance/Default/Resources/ValueConverters/ControlTypeToName',
        './Instance/Default/Resources/ValueConverters/FileListToArray',
        './Instance/Default/Resources/ValueConverters/ParticipantToParticipantInput',
        './Instance/Default/Resources/ValueConverters/BlobToUrl',
        './Instance/Default/Resources/ValueConverters/Conv1',
        './Instance/Default/Resources/ValueConverters/ObjectKeys',
        './Instance/Default/Resources/ValueConverters/SortIcon',
        './Instance/Default/Resources/ValueConverters/TypeToClass',
        './Instance/Default/Resources/ValueConverters/FieldNameToControl',
        './Instance/Default/Resources/ValueConverters/ValueToFormatedText',
        './Instance/Default/Resources/ValueConverters/ToLocaleDate',
        './Instance/Default/Resources/ValueConverters/ToLocaleDateTime',
        './Instance/Default/Resources/ValueConverters/ToLocaleTime',
        './Instance/Default/Resources/ValueConverters/ToLocaleDateTimeFromNow',
        './Instance/Default/Resources/ValueConverters/GetGridSettingsDeviceColumnStatus',
        './Instance/Default/Resources/ValueConverters/GridSettingsIncludesMultipleLayouts',
        './Instance/Default/Resources/ValueConverters/ArrayContainsObjectWithProperty',
        './Instance/Default/Resources/ValueConverters/ArrayNotContainsObjectWithProperty',
        './Instance/Default/Resources/ValueConverters/ValueToFormatedCurrency',
        './Instance/Default/Resources/ValueConverters/NumberToBootstrapSize',
        './Instance/Default/Resources/ValueConverters/ArrayContainsValue',
        './Instance/Default/Resources/ValueConverters/ArrayNotContainsValue',
        './Instance/Default/Resources/ValueConverters/CustomNumberFormatter',
        './Instance/Default/Resources/ValueConverters/DataTableCellFormat',
        './Instance/Default/Resources/ValueConverters/TrackChangesFormat',
        './Instance/Default/Resources/ValueConverters/LocalizeBySchema',
        './Instance/Default/Resources/ValueConverters/EmailHasSubfolders',
        './Instance/Default/Resources/ValueConverters/ToCorrectFileDataLength',
        './Instance/Default/Resources/ValueConverters/EmailHasNotSubfolders',
        './Instance/Default/Resources/ValueConverters/KanbanFieldFormat',
        './Instance/Default/Resources/ValueConverters/EnumFormatter',
        './Instance/Default/Resources/ValueConverters/DocumentsCount',
        './Instance/Default/Resources/ValueConverters/ToCount'
    ];

    // get standard resources from conofig wich will be customized
    let standardResources = Config.StandardResources();

    // chech if exists any resources
    if (ObjectHelper.IsNotNullAndUndefined(standardResources)) {

        // each all defined resources
        for (var index in resourceList) {

            // get current resources
            let currentResource = resourceList[index];

            // try to find any resource for current resource
            let existStandardRoute = standardResources.filter((item) => item.hasOwnProperty('OriginUrl') && item['OriginUrl'] == currentResource)[0];

            // check if exist resource for customization
            if (ObjectHelper.IsNotNullAndUndefined(existStandardRoute)) {

                // replace current resource
                resourceList[index] = existStandardRoute['NewUrl'];
            }
        }
    }

    // add the custom, per instance resources
    let customResources = Config.CustomResources();

    if (ObjectHelper.IsNotNullAndUndefined(customResources)) {
        for (let resource of customResources) {
            resourceList.push(resource.Url);
        }
    }

    //
    aurelia.use
        .globalResources(resourceList);

    //
    if (Environment.debug) {
        //aurelia.use.developmentLogging();
    }

    // Default html path
    ViewLocator.prototype.convertOriginToViewUrl = (origin) => {
        // get module ID
        let moduleId = origin.moduleId;

        // remove *.ts if module id contains them 
        let id = moduleId.endsWith('.ts') ? moduleId.substring(0, moduleId.length - 3) : moduleId;

        // check if id not contains '/Custom/' part of path
        if (id.indexOf('/Custom/') <= -1) {

            // if this is path to custom element or view
            if (id.indexOf('./Instance/' + Config.PathName()) == 0) {
                if (customResources.indexOf(id)) {
                    return `${id}.html`;
                }
            }

            // if id is path to cutomized folder
            if (id.indexOf('Instance/' + Config.PathName()) != -1)

                // replace path for HTML 
                return `${id.replace('Instance/' + Config.PathName(), 'General')}.html`;
            else

                // replace path for HTML
                return `${id.replace('Instance/Default', 'General')}.html`;
        }
        else {
            // return origin id (path)
            return `${id}.html`;
        }
    };

    //
    aurelia.start().then(async () => {
        var auth = aurelia.container.get(AuthService);

        //let newUrl: string = window.location.href;
        //let originalUrl: string = window.location.href;
//
        //if (newUrl.length != originalUrl.length) {
        //    newUrl = newUrl.replace('?', '')
        //    window.history.replaceState({}, document.title, newUrl);
        //}
        if (!auth.IsUserLogged()) {
            await auth.LoginAsPublicUser(null);
            Config.Init();
            await SystemService.Instance.GetSchema();
        }

        let root: string = 'Login';
        if (auth.IsUserLogged()) {
            root = 'App';
        } else {
            if (window.location.href.indexOf('#/PasswordResetConfirm') > 0) {
                root = 'PasswordResetConfirm';
            }
        }
        aurelia.setRoot(root);
    });
}
